import script from "./WidgetSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetSearch.vue?vue&type=script&setup=true&lang=js"

import "./WidgetSearch.vue?vue&type=style&index=0&id=66f2d7b7&lang=css"

const __exports__ = script;

export default __exports__